import {filter, take, timeout} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {Component, OnInit, OnDestroy} from "@angular/core";
import {BsModalRef} from "ngx-bootstrap/modal";
import {LocalizationService} from "../../../services/LocalizationService";
import {OrganizationService} from "../../../services/OrganizationService";
import {IModal} from "../IModal";
import {AuthService} from "../../../services/AuthService";
import {WaihonaUser} from "../../../domain/user/WaihonaUser";
import {IWaihonaUserAffiliation} from "../../../domain/IWaihonaUserAffiliation";
import {NGXLogger} from "ngx-logger";
import {Localization} from "../../../data/Localization";

@Component({
	selector: 'verify-user-modal',
	templateUrl: './verify-user-modal.component.html',
	styleUrls: ['./verify-user-modal.component.scss']
})

export class VerifyUserModalComponent implements OnInit, OnDestroy, IModal {

	private cbContext = Localization.template.modal.organization.verify_user_with_organization;
	public CB = {
		title: this.cbContext.title,
		body: this.cbContext.body,
		yes: Localization.template.buttons.yes,
		no: Localization.template.buttons.no,
		cancel: Localization.template.buttons.cancel,
	};

	public isLoadingYes:boolean = false;
    public decisionError:string = '';
    private decisionSubscription:Subscription;
	public isLoadingNo:boolean = false;
	public component:any;
	public content:{identity:IWaihonaUserAffiliation};

	constructor(public bsModalRef:BsModalRef,
				private authService:AuthService,
				private localizationService:LocalizationService,
				private organizationService:OrganizationService, protected logger:NGXLogger ) {
		this.localizationService.registerAndLocalize("VerifyUserModalComponent", this.CB);
	}

	public get currentUser():WaihonaUser {
		return this.authService.currentUser;
	}

	public ngOnInit():void {

	}
	public onProperties(properties:object):void {
		this.content = properties as {identity:IWaihonaUserAffiliation};
	}

    public onVerifyClick(isVerified:boolean):void {
        if (this.isLoadingYes || this.isLoadingNo) { return; }
        this.isLoadingYes = isVerified;
        this.isLoadingNo = !isVerified;
        this.decisionError = '';
        this.decisionSubscription = this.organizationService.verifyUser$(this.content.identity.orgGuid,
            this.content.identity.userGuid, isVerified).pipe(filter(result => !result.pending), take(1), timeout(15000)).subscribe({
            next: result => {
                this.isLoadingYes = this.isLoadingNo = false;
                if (result.wasSuccessful) { this.bsModalRef.hide(); }
                else { this.decisionError = 'The verification decision was not saved. Check the current membership and try again.'; }
            },
            error: () => {
                this.isLoadingYes = this.isLoadingNo = false;
                this.decisionError = 'The verification decision could not be confirmed. Please try again.';
            }
        });
    }

    public ngOnDestroy():void { this.decisionSubscription?.unsubscribe(); }



}
